import { NavLink } from "react-router-dom";
import { Divider, Grid, Header, Responsive, Tab } from "semantic-ui-react";
import FindPengeinstitut from "../../images/IkonHerfaarDuLetsikringer.svg";
import TjekDinPension from "../../images/IkonTjekDinPension.svg";
import withSizes from "react-sizes";
import appRoutes from "../../routes/appRoutes";
import { Route } from "react-router";
import CallForAction from "../common/CallForAction";

const mapSizesToProps = ({ width }) => ({
  tablet: width < Responsive.onlyTablet.minWidth,
});

const Investering = (props) => {
  const { tablet } = props;

  const invGrupper = [
    {
      gruppeNavn: "Investeringsfonde",
      profiler: [
        {
          profilNavn: "PFA Plus Høj risiko fonden",
          filNavn: "Hoej%20Risiko%20Fonden",
        },
        {
          profilNavn: "PFA Plus Lav risiko fonden",
          filNavn: "Lav%20Risiko%20Fonden",
        },
        {
          profilNavn: "PFA Indeks Plus Høj risiko fonden",
          filNavn: "Indeks%20Hoej%20Risiko%20Fonden",
          profilDatoSuffix: "100926",
        },
        {
          profilNavn: "PFA Indeks Plus Lav risiko fonden",
          filNavn: "Indeks%20Lav%20Risiko%20Fonden",
          profilDatoSuffix: "100926",
        },
        {
          profilNavn: "PFA Klima Plus Høj risiko fonden",
          filNavn: "Klima%20Hoej%20Risiko%20Fonden",
        },
        {
          profilNavn: "PFA Klima Plus Lav risiko fonden",
          filNavn: "Klima%20Lav%20Risiko%20Fonden",
        },
      ],
    },
    {
      gruppeNavn: "PFA Investerer - PFA Plus",
      profiler: [
        {
          profilNavn: "PFA Plus Profil Forsigtig",
          filNavn: "Profil%20Forsigtig",
        },
        {
          profilNavn: "PFA Plus Profil Lav",
          filNavn: "Profil%20Lav",
        },
        {
          profilNavn: "PFA Plus Profil Middel",
          filNavn: "Profil%20Middel",
        },
        {
          profilNavn: "PFA Plus Profil Høj",
          filNavn: "Profil%20Hoej",
        },
      ],
    },
    {
      gruppeNavn: "PFA Investerer - PFA Indeks Plus",
      profiler: [
        {
          profilNavn: "PFA Indeks Plus Profil Forsigtig",
          filNavn: "Indeks%20Profil%20Forsigtig",
          profilDatoSuffix: "100926",
        },
        {
          profilNavn: "PFA Indeks Plus Profil Lav",
          filNavn: "Indeks%20Profil%20Lav",
          profilDatoSuffix: "100926",
        },
        {
          profilNavn: "PFA Indeks Plus Profil Middel",
          filNavn: "Indeks%20Profil%20Middel",
          profilDatoSuffix: "100926",
        },
        {
          profilNavn: "PFA Indeks Plus Profil Høj",
          filNavn: "Indeks%20Profil%20Hoej",
          profilDatoSuffix: "100926",
        },
      ],
    },
    {
      gruppeNavn: "PFA Investerer - PFA Klima Plus",
      profiler: [
        {
          profilNavn: "PFA Klima Plus Profil Forsigtig",
          filNavn: "Klima%20Profil%20Forsigtig",
        },
        {
          profilNavn: "PFA Klima Plus Profil Lav",
          filNavn: "Klima%20Profil%20Lav",
        },
        {
          profilNavn: "PFA Klima Plus Profil Middel",
          filNavn: "Klima%20Profil%20Middel",
        },
        {
          profilNavn: "PFA Klima Plus Profil Høj",
          filNavn: "Klima%20Profil%20Hoej",
        },
      ],
    },
  ];
  const datoSuffix = "300425";

  const panes = [
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_AFKAST,
        exact: true,
        icon: "line chart",
        content: tablet ? null : "Investering og afkast",
        key: "invafkast",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_AFKAST}
          key={appRoutes.INVESTERING_AFKAST}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <h4>Hvordan bliver mine penge investeret?</h4>
                    <p>
                      Når du køber en Letsikring af indtægt ved pension, bliver
                      din opsparing investeret i markedsrente, dvs. i en
                      blanding af aktier, obligationer, ejendomme og alternative
                      investeringer.
                    </p>
                    <p>
                      Potentialet for afkast hænger sammen med risiko: Jo højere
                      risiko, des større potentiale for højt afkast og omvendt.
                    </p>
                    <p>Læs om dine investeringsmuligheder på fanebladene.</p>
                    <h4>Se dit afkast</h4>
                    <p>
                      Du kan se dit afkast i{" "}
                      <a
                        href="https://www.letportal.dk"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Letportalen
                      </a>{" "}
                      eller via din mobil- eller netbank.
                    </p>
                    <p>
                      <a
                        className="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/dokumenter/afkast"
                      >
                        Se PFA's investeringsafkast.
                      </a>
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>PFA KundeKapital</h4>
                    <p>
                      Du kan vælge, at en del af dine løbende indbetalinger,
                      indskud og overførsler til din opsparing skal gå til PFA
                      KundeKapital, som er ansvarlig kapital i PFA Pension. Du
                      kan ikke vælge, hvordan din opsparing i PFA KundeKapital
                      bliver investeret.
                    </p>
                    <p>Du kan læse mere under fanen ”PFA KundeKapital”.</p>

                    <h4>Risikomærkning</h4>
                    <p>
                      Brancheorganisation for forsikrings- og pensionsselskaber
                      i Danmark, F&P, har lavet et værktøj, hvor du kan
                      sammenligne risikoen på tværs af pensionsselskaber. Med
                      dette værktøj kan du se risikoen i dit eget
                      pensionsprodukt og sammenligne den med gennemsnittet af
                      risikoen for pensionsprodukter i markedsrente på tværs af
                      pensionsselskaber.
                    </p>
                    <p>
                      <a
                        className="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.faktaompension.dk/risiko"
                      >
                        Gå til F&P’s værktøj Min Pensionsrisiko
                      </a>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_KONCEPTER,
        exact: true,
        icon: "pie chart",
        content: tablet ? null : "Koncepter",
        key: "profiler",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_KONCEPTER}
          key={appRoutes.INVESTERING_KONCEPTER}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <p>
                      Du har flere muligheder for at sammensætte din
                      investering, så den passer til dine ønsker og behov.
                    </p>
                    <p>
                      Først vælger du mellem to investeringskoncepter – alt
                      efter om du ønsker, at risikoen i din investering
                      automatisk bliver nedtrappet eller ej.
                    </p>
                    <p>
                      Herefter vælger du den investeringsrisiko, der passer
                      bedst til dig. Jo højere din valgte risiko er, jo højere
                      er det forventede afkast men også risikoen for tab og
                      udsving undervejs. Endelig har du også mulighed for at
                      vælge et særligt fokus for din investering.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>Investeringskonceptet PFA Investerer</h4>
                    <p>
                      I PFA Investerer bliver din investeringsrisiko nedtrappet
                      i takt med at du nærmer dig pensionsalderen, og
                      nedtrapningen fortsætter også efter, at du er påbegyndt
                      udbetaling. Det sker for at reducere risikoen for store
                      udsving i din opsparing i den sidste del af
                      opsparingsperioden samt i pensionstilværelsen, hvor
                      behovet for tryghed typisk er større, og du har mindre tid
                      til at indhente det tabte.
                    </p>
                    <p>
                      Du kan i PFA Investerer vælge mellem tre
                      investeringsprofiler: Profil Lav, Profil Middel og Profil
                      Høj. De tre investeringsprofiler har forskellige
                      potentialer for afkast og forskellige grader af risiko
                      knyttet til sig. Profil Lav har den laveste risiko for tab
                      og det mindste potentiale for et højt afkast. Profil Høj
                      har den bedste mulighed for et højt afkast, men også den
                      højeste risiko for tab.
                    </p>
                    <h4>Investeringskonceptet PFA Fleksibel</h4>
                    <p>
                      I PFA Fleksibel fastsætter du selv risikoniveauet for din
                      opsparing ved at vælge fordelingen mellem PFA’s lav og høj
                      risiko fonde.
                    </p>
                    <p>
                      I PFA Fleksibel bliver risikoen ikke automatisk nedtrappet
                      i takt med, at du nærmer dig pensionsalderen, og risikoen
                      er fast også efter, at du er påbegyndt udbetaling. Du skal
                      derfor selv være opmærksom på løbende at tilpasse
                      risikoen, så den passer til din alder og situation.
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_FOKUS,
        exact: true,
        icon: "target",
        content: tablet ? null : "Fokus",
        key: "invfokus",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_FOKUS}
          key={appRoutes.INVESTERING_FOKUS}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <h4>Skal din investering have et bestemt fokus?</h4>
                    <p>
                      Du kan vælge mellem 3 investeringsfokus, og du vælger
                      selv, hvilken fordeling du ønsker.
                    </p>
                    <p>
                      Uanset hvilket investeringsfokus du vælger, arbejder PFA
                      systematisk med at integrere hensyn til klima og miljø,
                      selskabsledelse og social ansvarlighed i alle
                      investeringer. Derudover indgår overholdelse af
                      internationale normer for ansvarlighed – blandt andet
                      inden for menneskerettigheder, arbejdstagerrettigheder,
                      miljø og antikorruption – i alle PFA's
                      investeringsprodukter.
                    </p>
                    <h4>PFA Plus</h4>
                    <p>
                      Har et bredt investeringsfokus, der favner hele PFA’s
                      investeringsunivers inkl. unoterede investeringer, som fx
                      ejendomme. Investeringerne tilpasses løbende af PFA’s
                      investeringseksperter til verdenssituationen, og der kan
                      investeres i fx startups, sikkerhed og grøn omstilling.
                    </p>
                    <p>
                      Samtidig benytter PFA’s investeringseksperter forskellige
                      redskaber til at mindske risici og beskytte din opsparing
                      mod store udsving i markedet.
                    </p>
                    <p>
                      <a href="/pfaplus">Læs mere om PFA Plus</a>
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>PFA Indeks Plus</h4>

                    <p>
                      Har fokus på at investere indeksnært og følger udviklingen
                      i faste udvalgte indeks for børsnoterede aktier og
                      obligationer. Med PFA Indeks Plus fravælger du således
                      aktiv forvaltning af din opsparing. Det betyder, at din
                      opsparing ikke løbende vil blive justeret af PFA’s
                      investeringseksperter i forhold til den aktuelle
                      verdenssituation. Risikoen i PFA Indeks Plus vil være
                      sammenlignelig med PFA Plus på lang sigt, men da produktet
                      er mere enkelt, kan der være større udsving i afkastet på
                      kort sigt. Dette kan være både i positiv og negativ
                      retning. Produktet vil samtidig være mere følsomt over for
                      valutakursudsving, da valutakursrisikoen på aktier ikke er
                      afdækket.
                    </p>
                    <p>
                      <a href="/indeks">Læs mere om PFA Indeks Plus</a>
                    </p>

                    <h4>PFA Klima Plus</h4>
                    <p>
                      Har et skærpet fokus på klima for at fremme den grønne
                      omstilling. Der investeres bredt med fokus på et lavere CO
                      <sub>2</sub>
                      -aftryk i bl.a. unoterede investeringer og skovbrug, der
                      trækker CO<sub>2</sub> ud af atmosfæren. Investeringerne
                      tilpasses løbende til verdenssituationen, og der
                      investeres ikke i olie og gasselskaber samt
                      våbenproducenter.
                    </p>
                    <p>
                      <a href="/klima">Læs mere om PFA Klima Plus</a>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_FONDE,
        exact: true,
        icon: "bar chart",
        content: tablet ? null : "Fonde",
        key: "invfonde",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_FONDE}
          key={appRoutes.INVESTERING_FONDE}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <h4>Sådan foregår investeringen af din opsparing</h4>
                    <p>
                      Alle investeringer i din pensionsopsparing foregår via
                      PFA’s 6 investeringsfonde: PFA Plus Lav risiko fonden, PFA
                      Plus Høj risiko fonden, PFA Klima Plus Lav risiko fonden,
                      PFA Klima Plus Høj risiko fonden, PFA Indeks Plus Lav
                      risiko fonden og PFA Indeks Plus Høj risiko fonden. Alt
                      efter koncept, risiko og fokus er fordelingen i fondene
                      forskellig.
                    </p>
                    <p>
                      I alle fondene investeres der bredt på tværs af sektorer
                      og geografi for at sprede risikoen mest muligt.
                    </p>
                    <p>
                      Høj risiko fondene investerer hovedsageligt i aktier og
                      tilsvarende investeringer, og investeringerne er derfor
                      primært orienteret mod børsnoterede og unoterede selskaber
                      samt infrastruktur med høj risiko. Lav risiko fondene
                      investerer hovedsageligt i obligationer og tilsvarende
                      investeringer, bl.a. kreditobligationer,
                      statsobligationer, infrastruktur, ejendomme og skov.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>Beholdningslister</h4>
                    <p>
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/aktier"
                      >
                        Aktieliste (PDF)
                      </a>
                      <br />
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/obligationer"
                      >
                        Obligationsliste (PDF)
                      </a>
                      <br />
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/statsobligationer"
                      >
                        Landeliste over statsobligationer (PDF)
                      </a>
                      <br />
                      <a
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer"
                        href="/dokumenter/alternativeinvesteringer"
                      >
                        Liste over alternative investeringer og ejendomme (PDF)
                      </a>
                      <br />
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_KUNDEKAPITAL,
        exact: true,
        icon: "users",
        content: tablet ? null : "PFA KundeKapital",
        key: "kundekapital",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_KUNDEKAPITAL}
          key={appRoutes.INVESTERING_KUNDEKAPITAL}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <p>
                      Du kan vælge, at en del af dine løbende indbetalinger,
                      indskud og overførsler skal gå til PFA KundeKapital, som
                      er PFA’s model for risiko- og overskudsdeling.
                    </p>
                    <p>
                      KundeKapital er ansvarlig kapital i PFA Pension, hvilket
                      betyder, at KundeKapital får en andel i såvel overskud som
                      tab i PFA Pension. I gode tider giver det mulighed for at
                      få en høj forrentning af KundeKapital. I dårlige tider kan
                      KundeKapitalen blive mindre (negativ forrentning) og i
                      yderste konsekvens tabes helt.{" "}
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    <p>
                      Læs mere på{" "}
                      <a
                        className="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.pfa.dk/privat/opsparing/pfa-kundekapital/"
                      >
                        https://www.pfa.dk/privat/opsparing/pfa-kundekapital/
                      </a>
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
    {
      menuItem: {
        as: NavLink,
        to: appRoutes.INVESTERING_BAEREDYGTIGHED,
        exact: true,
        icon: "recycle",
        content: tablet ? null : "Bæredygtighedsrelaterede oplysninger",
        key: "baeredygtighed",
      },
      pane: (
        <Route
          path={appRoutes.INVESTERING_BAEREDYGTIGHED}
          key={appRoutes.INVESTERING_BAEREDYGTIGHED}
          exact
          render={() => (
            <Tab.Pane>
              <Grid>
                <Grid.Row columns={tablet ? 1 : 2}>
                  <Grid.Column>
                    <h4>Investering og bæredygtighed</h4>
                    <p>
                      EU har som del af arbejdet med bæredygtig økonomi vedtaget
                      rammer for, hvordan udbydere af finansielle produkter skal
                      klassificere, dokumentere, rådgive og kommunikere om
                      bæredygtighed i forhold sine finansielle produkter,
                      herunder pensionsprodukter. Disse rammer er nærmere
                      beskrevet i EU’s disclosureforordning.{" "}
                    </p>
                    <p>
                      Derfor har PFA lavet en bæredygtighedsbeskrivelse for hver
                      type af investeringsprofil og investeringskoncept. Du kan
                      se dem på siden her.
                    </p>
                  </Grid.Column>
                  <Grid.Column>
                    {invGrupper.map((gruppe, i) => {
                      return (
                        <div key={i}>
                          <h4>{gruppe.gruppeNavn}</h4>
                          {gruppe.profiler.map((profil, i) => {
                            return (
                              <div style={{ marginBottom: 20 }}>
                                <div>{profil.profilNavn}</div>
                                <a
                                  target="_blank"
                                  className="link"
                                  rel="noopener noreferrer"
                                  href={
                                    "/dokumenter/Praekontraktuelt%20information%20" +
                                    profil.filNavn +
                                    "-" +
                                    (profil.profilDatoSuffix || datoSuffix)
                                  }
                                >
                                  Prækontraktuel information
                                </a>
                                <br />
                                <a
                                  target="_blank"
                                  className="link"
                                  rel="noopener noreferrer"
                                  href={
                                    "/dokumenter/Baeredygtighedsrelaterede%20oplysninger%20" +
                                    profil.filNavn +
                                    "-" +
                                    (profil.profilDatoSuffix || datoSuffix)
                                  }
                                >
                                  Bæredygtighedsrelaterede oplysninger
                                </a>
                                <br />
                                <a
                                  target="_blank"
                                  className="link"
                                  rel="noopener noreferrer"
                                  href={
                                    "/dokumenter/Sammenfatning_" +
                                    profil.filNavn +
                                    "-" +
                                    (profil.profilDatoSuffix || datoSuffix)
                                  }
                                >
                                  Sammenfatning - Bæredygtighedsrelaterede
                                  oplysninger
                                </a>
                                <br />
                                <a
                                  style={{
                                    display: !!profil.profilDatoSuffix
                                      ? "none"
                                      : "block",
                                  }}
                                  target="_blank"
                                  className="link"
                                  rel="noopener noreferrer"
                                  href={
                                    "/dokumenter/Periodisk%20rapportering%20" +
                                    profil.filNavn +
                                    "-" +
                                    (profil.profilDatoSuffix || datoSuffix)
                                  }
                                >
                                  Periodisk rapportering
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                    <h4>Tillæg, som gælder for al investering</h4>
                    <a
                      target="_blank"
                      className="link"
                      rel="noopener noreferrer"
                      href={
                        "/dokumenter/PFA%20Baeredygtighedsrisici%20paa%20produktniveau-100926"
                      }
                    >
                      Bæredygtighedsrisici på produktniveau
                    </a>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          )}
        />
      ),
    },
  ];

  return (
    <div>
      <Header as="h2" textAlign="center">
        Sådan bliver dine penge investeret
      </Header>
      <Divider hidden />
      <p>
        Letpension formidler pensions- og forsikringsløsninger for PFA Pension.
      </p>
      <p>
        PFA leverer pensions- og forsikringsprodukterne og står for
        investeringen af de opsparede penge.
      </p>

      <Tab renderActiveOnly={false} activeIndex={-1} panes={panes} />
      <Divider section hidden />

      <Grid centered stackable columns={2}>
        <Grid.Row>
          <CallForAction
            icon={FindPengeinstitut}
            color="#e49d3b"
            text="Her får du Letsikringer"
            link={appRoutes.BLIV_KUNDE}
          />
          <CallForAction
            icon={TjekDinPension}
            color="#b9c35d"
            text="Tjek din pension"
            link={appRoutes.TJEK_DIN_PENSION}
          />
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default withSizes(mapSizesToProps)(Investering);
